import submitCommand from '../../../services/submitCommand';

export const updateEasyLinkInviteName = (inviteId: string, name: string, initiatingUserId: string) => {
  const cmd = { id: inviteId, name: name, initiatingUserId: initiatingUserId };
  return submitCommand(inviteId, cmd, 'SetMembershipCodeName', 'MembershipCodeNameSet', 'MembershipCodeError');
};
